var $ = bookedby.deps != null ? bookedby.deps.$ : global.$;
var _ = bookedby.deps != null ? bookedby.deps._ : global._;

var moment = require('moment-timezone');

var SelectorView = require('./selector');

var EmployeeSelectorView = SelectorView.extend({
  template: 'components.employeeSelector',
  events: {
    'click .caret': 'focusOnInput',
    'click .select-addon': 'focusOnInputWithAddon',
    'click .select-employee-img': 'focusOnInputWithImg',
    'click .select-addon-caret': 'focusOnInputWithAddon',
    'change .select-employee': 'valueChanged',
    'focus .select-employee': 'showList',
    'click .select-employee': 'focusOnInput',
    'blur .select-employee': 'showList',
    'focusout .select-employee': 'hideAllLists',
    'click .select-employee-list li:not([data-disabled])': 'selectEmployee',
    'keydown .select-employee': 'keyActions'
  },

  initialize: function(options) {
    options = options || {};
    SelectorView.prototype.initialize.apply(this, [options]);
    this.serviceProperty = options.serviceProperty || 'service';
    this.bindings = {};
    if (this.model.get(this.boundProperty + '_invalid') !== undefined) {
      this.bindings['.form-group'] = "classes:{'has-error':" + this.boundProperty + "_invalid}";
      this.bindings['.help-block'] = "text:" + this.boundProperty + "_error,toggle:" + this.boundProperty + "_invalid";
    }
    this.guestIndexProperty = options.guestIndexProperty || 'index';
    this.eventsReady = false;
    this.matchWithServices = true;
    this.filterByWaitListAvailability = false;
    this.showFirstAvailablePlaceholder = false;
    this.reviewsAddSeeAll = false;
    this.disabled = false;

    document.addEventListener('click', _.bind(function(e) {
      if (this.isIe && this.$el[0].id !== e.target.id && e.target.id !== 'confirmationProvider') {
        e.type = 'clickOutside';
        this.hideAllLists(e)
      }
    }, this))
  },

  beforeRender: function() {
    if (!this.eventsReady) {
      this.model.on('change:' + this.boundProperty, this.modelChanged, this);
      this.model.on('change:' + this.serviceProperty, this.render, this);
      if (this.filterByWaitListAvailability) {
        if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking && this.model.get(this.guestIndexProperty) > -1) {
          bookedby.app.serviceManager.on('employeeByGuestWaitTimesUpdated', this.render, this);
        } else {
          bookedby.app.serviceManager.on('waitTimesUpdated', this.render, this);
        }
      }
      this.eventsReady = true;
    }
  },

  afterRender: function() {
    this.applyBindings();
    this.$input = this.$el.find('.select-employee');
    this.$inputImg = this.$el.find('.select-employee-img');
    this.modelChanged();
    var guestNumber = this.model.attributes.guest;
    var selectInputId = 'confirmationProvider_' + guestNumber;
    this.$listId = 'selectEmployeeList';
    if (this.$el.parent().hasClass('guestSelectContainer')) {
        this.$el.find('.inputEmploeeSelect-js').attr('id', selectInputId);
    }
  },

  cleanup: function() {
    this.model.off('change:' + this.boundProperty, this.modelChanged, this);
    this.model.off('change:' + this.serviceProperty, this.render, this);
    if (this.filterByWaitListAvailability) {
      if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking && this.model.get(this.guestIndexProperty) > -1) {
        bookedby.app.serviceManager.off('employeeByGuestWaitTimesUpdated', this.render, this);
      } else {
        bookedby.app.serviceManager.off('waitTimesUpdated', this.render, this);
      }
    }
    this.removeBindings();
    this.eventsReady = false;
  },

  serialize: function() {
    var value = this.model.get(this.boundProperty);
    var service = this.model.get(this.serviceProperty);

    var employeesForService = [];

    if (this.matchWithServices !== true) {
      employeesForService = bookedby.app.serviceManager.allEmployees.toArray();
    } else {
      if (service != null) {
        employeesForService = bookedby.app.serviceManager.allEmployees.filter(function(employee) {
          return bookedby.app.serviceManager.employeeHasService(employee, service);
        });
      }
    }

    if (this.filterByWaitListAvailability) {
      var filterFunc = function(x) { return x.hideEmp !== true && x.notAvail !== true; };
      var availableEmployees = [];
      if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking && this.model.get(this.guestIndexProperty) > -1) {
        availableEmployees = _.map(_.filter(bookedby.app.serviceManager.employeeByGuestWaitTimes[this.model.get(this.guestIndexProperty)], filterFunc), function (x) { return String(x.employeeId); });
      } else {
        availableEmployees = _.map(_.filter(bookedby.app.serviceManager.employeeWaitTimesMap, filterFunc), function (x) { return String(x.employeeId); });
      }

      employeesForService = _.filter(employeesForService, function(x) {
        return _.contains(availableEmployees, '' + x.id);
      });
    }

    var employeeJson = _.map(employeesForService, _.bind(function(employee) {
      var empJSON = employee.toJSON();

      if (this.filterByWaitListAvailability) {
        if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking && this.model.get(this.guestIndexProperty) > -1) {
          empJSON.waitTime = bookedby.app.serviceManager.employeeByGuestWaitTimes[this.model.get(this.guestIndexProperty)][employee.id].waitTime;
        } else {
          empJSON.waitTime = bookedby.app.serviceManager.employeeWaitTimesMap[employee.id].waitTime;
        }
      }

      return empJSON;
    }, this));

    if (this.filterByWaitListAvailability) {
      employeeJson = _.sortBy(employeeJson, 'waitTime');
    }

    var minWaitingTime = 0;
    if (this.filterByWaitListAvailability) {
      if (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking && this.model.get(this.guestIndexProperty) > -1) {
        minWaitingTime = _.min(_.map(bookedby.app.serviceManager.employeeByGuestWaitTimes[this.model.get(this.guestIndexProperty)], function(x) { return x.waitTime; }));
      } else {
        minWaitingTime = _.min(_.map(bookedby.app.serviceManager.employeeWaitTimesMap, function (x) { return x.waitTime; }));
      }
    }

    var employeesWithSchedules = _.values(bookedby.app.serviceManager.employeesWithWorkSchedule);
    if (service != null && this.matchWithServices === true) {
      employeesWithSchedules = _.filter(employeesWithSchedules, _.bind(function(schedule) {
        var employee = bookedby.app.serviceManager.employeeMap[schedule.employeeId];
        var shouldHide = false;
        if (this.filterByWaitListAvailability) {
          var targetMap = (bookedby.staticData.storeGroupSettings.allowMultipleGuestBooking && this.model.get(this.guestIndexProperty) > -1) ? bookedby.app.serviceManager.employeeByGuestWaitTimes[this.model.get(this.guestIndexProperty)] : bookedby.app.serviceManager.employeeWaitTimesMap;
          shouldHide = _.has(targetMap, '' + schedule.employeeId) && targetMap[schedule.employeeId].hideEmp == true;
        }
        return !shouldHide && bookedby.app.serviceManager.employeeHasService(employee, service);
      }, this));
    }

    employeesWithSchedules = _.filter(employeesWithSchedules, function(x) {
      return !_.contains(availableEmployees, '' + x.employeeId);
    });

    var employeeSchedules = _.map(_.sortBy(employeesWithSchedules, 'startTime'), _.bind(function(schedule) {
      var employee = bookedby.app.serviceManager.employeeMap[schedule.employeeId];
      var employeeWaitTimesMap = bookedby.app.serviceManager.employeeWaitTimesMap[schedule.employeeId];
      var employeeStartTime = employeeWaitTimesMap ? employeeWaitTimesMap.time : schedule.startTime;
      var startingAt = bookedby.helpers.timestampAsTimeFormat(bookedby.helpers.getNewMomentWithTimeOfDayBySecond(moment().tz(schedule.timeZone), employeeStartTime));
      return {
        id: schedule.employeeId,
        name: employee.get('name'),
        photoId: employee.get('photoId'),
        startingAt: startingAt
      }
    }, this));

    return {
      choices: employeeJson,
      showFirstAvailable: this.showFirstAvailablePlaceholder,
      reviewsAddSeeAll: this.reviewsAddSeeAll,
      showWaitingTime: this.filterByWaitListAvailability,
      minWaitingTime: minWaitingTime,
      employeeSchedules: employeeSchedules
    }
  },
  valueChanged: function() {
    var selectedId = this.$input.attr('data-id');
    if (selectedId == '0') {
      this.model.set(this.boundProperty, 0);
    } else if (selectedId == null || selectedId == '') {
      this.model.set(this.boundProperty, null);
    } else {
      this.model.set(this.boundProperty, bookedby.app.serviceManager.employeeMap[selectedId]);
    }
  },

  modelChanged: function() {
    var selectedItem = this.model.get(this.boundProperty);
    if (selectedItem == 0) {
      return;
    }
    if (selectedItem == null) {
      //this.$input.val('');
      this.$input.attr('data-id', '');

      if (this.showFirstAvailablePlaceholder) {
        this.selectItem({
          id: '',
          name: 'First Available'
        });
      }

      if (this.reviewsAddSeeAll) {
        this.$inputImg.attr('src', '');
        this.$inputImg.addClass('hidden');
        $('.employee-selector').attr('aria-expanded', 'false');
      }
    } else {
      id = selectedItem.get('id');
      name = selectedItem.get('name');
      this.$input.attr('data-id', id);
      this.$input.val(name);

      if (this.reviewsAddSeeAll) {
        var self = this;
        this.$inputImg.fadeOut(400, function() {
          self.$inputImg.attr('src', bookedby.helpers.employeePhoto(selectedItem.attributes, 'thumb', bookedby.baseURL));
        }).fadeIn(400);

        this.$inputImg.removeClass('hidden');
        $('.employee-selector').attr('aria-expanded', 'true');
      }
    }
  },

  selectEmployee: function(e) {
    e.preventDefault();
    var selectedLi = $(e.currentTarget);
    var employeeId = selectedLi.data('id');

    var itemObject = {
      id: employeeId,
      name: selectedLi.find('span').text()
    };

    this.selectItem(itemObject);

    if (this.reviewsAddSeeAll && itemObject.id == -1) {
      this.$input.val('');
      this.$input.attr('data-id', '');
      this.$inputImg.attr('src', '');
      this.$inputImg.addClass('hidden');
      $('.employee-selector').attr('aria-expanded', 'false');
    }
  },

  selectItemWithEnterKey: function(key, keys) {
    if (key == keys.enter) {
      var el = this.$('.select-list .active').first();

      if (el.attr('data-disabled')) {
        return;
      }

      SelectorView.prototype.selectItemWithEnterKey.apply(this, [key, keys]);
    }
  },

  navigateListWithArrowKeys: function(key, keys) {
    var listId = this.$listId;
    switch(key) {
      case keys.up:
        this.navigateList(listId, 'up');
      break;
      case keys.down:
        this.navigateList(listId, 'down');
      break;
      case keys.tab:
        this.navigateList(listId, 'down');
      break;
    }
  }
});

module.exports = EmployeeSelectorView;
